import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import moment from "moment";
import { SET_DOCUMENTS, SET_DOCUMENT_COMMENTS, SET_DOCUMENT_CLASSIFICATIONS, SET_DOCUMENT_REQUEST_LISTS, SET_DOCUMENT_REQUESTS, SET_SAMPLE_DOCUMENTS, SET_MARKED_DOCUMENT_CLASSIFICATION, CLEAR_MARKED_DOCUMENT_CLASSIFICATION, SET_DOCUMENT_CLASSIFICATION_DESCRIPTION, ADD_DOCUMENT_COMMENT, REMOVE_DOCUMENT_COMMENT, ADD_DOCUMENT_CLASSIFICATION, REMOVE_DOCUMENT_CLASSIFICATION, EDIT_DOCUMENT_DETAILS, REMOVE_DOCUMENT_FROM_CLASSIFICATION, ADD_DOCUMENTS_TO_CLASSIFICATION, SET_DOCUMENT_REQUEST_EMAIL_TEMPLATES, SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE, SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE_DETAILS, REMOVE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, SET_NEW_DOCUMENT_REQUEST_EMAIL_TEMPLATE, SET_DOCUMENT_REQUEST_LIST, SET_DRAFT_TEMPLATE_NAME, SET_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION, REMOVE_DOCUMENT_REQUEST_CLASSIFICATION, ADD_DOCUMENT_REQUEST_CLASSIFICATION, EDIT_REQUEST_LIST_DOCUMENT_DETAILS, REMOVE_DOCUMENT_FROM_REQUEST_CLASSIFICATION, ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION, ADD_DOCUMENT_REQUEST_LIST, EMPTY_REQUEST_LIST, DELETE_REQUEST_LIST, SET_DOCUMENT_CLASSIFICATION_SENT_STATUS, SET_DOCUMENT_TYPES, UPDATE_DOCUMENT_TYPE, REMOVE_DOCUMENT_TYPE, SET_DOCUMENT_TYPES_ORDER, SET_DOCUMENT_LABEL, ADD_DOCUMENT_LABEL, DELETE_DOCUMENT_LABEL, DELETE_LABEL_TO_DOCUMENT, SET_DOCUMENT_LABELS, SET_DOCUMENT_NEW_COMMENTS_NUMBER, SET_DOCUMENT_REQUESTS_ORDER, SET_EXTRACTED_VALUES } from "./documents-mutations";
import { getDocumentClassifications, downloadDocument, getDocumentRequestList, downloadDocumentNoClient, downloadAllDocumentsAsPdf, markUploadCompleted, updateRequestDetails, sendComment, deleteDocumentRequest, createDocumentClassification, renameDocument, deleteDocument, updateDocumentStatus, getEmailTemplates, getEmailTemplate, updateEmailTemplate, deleteEmailTemplate, createEmailTemplate, downloadAllDocumentsAsZip, resetGuestUpload, createOrUpdateDocumentRequestList, updateDocumentRequestSort, updateDocumentRequestItem, deleteDocumentRequestItem, deleteDocumentRequestSample, markDocumentRequestUploadCompleted, getDocumentTypes, updateDocumentType, deleteDocumentType, createDocumentType, documentTypesOrder, moveDocument, createDocumentTag, editDocumentTag, removeLabelToDocument, addLabelToDocument, deleteDocumentTag, getDocumentLabels, markMessagesAsRead, documentRequestsOrder, sendDocumentsToLender, createSignedUrls, extractDocumentValues } from "../api/documents-api";
import { normalize } from "normalizr";
import { classificationListSchema, documentRequestListSchema, documentTypesSchema, documentRequestTemplateSchema, documentLabelsSchema } from "./documents-schema";
import Err from "../../../../../routes/error";
import { getSignedURL } from "./../api/documents-api";
import { putS3Data } from "@Shared/utils/ajax";
import { openFileDialog, pollApiCall } from "@Shared/utils/utils";
import Amplitude from "@Shared/utils/amplitude";
import { showToast } from "@Shared/utils/constants";
import { rotateFileIfNeeded, sampleDocumentsToRealDocuments } from "./document-utils";
import isPDFEncrypted from "@Shared/utils/is-pdf-encrypted";
import i18n from "@Shared/@i18n";
import { chunk, cloneDeep, groupBy, isEmpty, map, pick, slice, values } from "lodash";
import { getFileName } from "@Broker/js/custom/utils";
import { v4 as uuidv4 } from "uuid";
export const LOAD_DOCUMENTS = "LOAD_DOCUMENTS";
export const LOAD_REQUEST_LISTS = "LOAD_REQUEST_LISTS";
export const DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT";
export const DOWNLOAD_COMBINED_PDF = "DOWNLOAD_COMBINED_PDF";
export const GET_SIGNED_URL = "GET_SIGNED_URL";
export const MARK_UPLOAD_COMPLETED = "MARK_UPLOAD_COMPLETED";
export const MARK_DOCUMENT_CLASSIFICATIONS = "MARK_DOCUMENT_CLASSIFICATIONS";
export const UNMARK_DOCUMENT_CLASSIFICATIONS = "UNMARK_DOCUMENT_CLASSIFICATIONS";
export const EMPTY_MARKED_DOCUMENT_CLASSIFICATIONS = "EMPTY_MARKED_DOCUMENT_CLASSIFICATIONS";
export const SAVE_DOCUMENT_CLASSIFICATION_DESCRIPTION = "SAVE_DOCUMENT_CLASSIFICATION_DESCRIPTION";
export const SEND_DOCUMENT_COMMENT = "SEND_DOCUMENT_COMMENT";
export const DELETE_DOCUMENT_CLASSIFICATION = "DELETE_DOCUMENT_CLASSIFICATION";
export const DELETE_DOCUMENT_REQUEST_CLASSIFICATION = "DELETE_DOCUMENT_REQUEST_CLASSIFICATION";
export const DELETE_DOCUMENT_FROM_REQUEST_CLASSIFICATION = "DELETE_DOCUMENT_FROM_REQUEST_CLASSIFICATION";
export const UPLOAD_DOCUMENT_TO_CLASSIFICATION = "UPLOAD_DOCUMENT_TO_CLASSIFICATION";
export const RENAME_DOCUMENT = "RENAME_DOCUMENT";
export const DELETE_DOCUMENT_FROM_CLASSIFICATION = "DELETE_DOCUMENT_FROM_CLASSIFICATION";
export const CREATE_DOCUMENT_CLASSIFICATIONS = "CREATE_DOCUMENT_CLASSIFICATIONS";
export const UPDATE_DOCUMENT_STATUS = "UPDATE_DOCUMENT_STATUS";
export const LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATES = "LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATES";
export const LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATE = "LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATE";
export const UPDATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE = "UPDATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE";
export const DELETE_DOCUMENT_REQUEST_EMAIL_TEMPLATE = "DELETE_DOCUMENT_REQUEST_EMAIL_TEMPLATE";
export const CREATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE = "CREATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE";
export const DOWNLOAD_ALL_PDF = "DOWNLOAD_ALL_PDF";
export const RESET_SECURE_DETAILS = "RESET_SECURE_DETAILS";
export const SAVE_REQUEST_LIST = "SAVE_REQUEST_LIST";
export const UPDATE_REQUEST_LIST_ORDER = "UPDATE_REQUEST_LIST_ORDER";
export const SAVE_REQUEST_LIST_ORDER = "SAVE_REQUEST_LIST_ORDER";
export const SAVE_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION = "SAVE_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION";
export const RENAME_REQUEST_LIST_DOCUMENT = "RENAME_REQUEST_LIST_DOCUMENT";
export const UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION = "UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION";
export const DOWNLOAD_DOCUMENT_NO_CLIENT = "DOWNLOAD_DOCUMENT_NO_CLIENT";
export const CLEAR_REQUEST_LIST = "CLEAR_REQUEST_LIST";
export const DELETE_DOCUMENT_TEMPLATE = "DELETE_DOCUMENT_TEMPLATE";
export const UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS = "UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS";
export const LOAD_DOCUMENT_TYPES = "LOAD_DOCUMENT_TYPES";
export const EDIT_DOCUMENT_TYPE = "EDIT_DOCUMENT_TYPE";
export const DELETE_DOCUMENT_TYPE = "DELETE_DOCUMENT_TYPE";
export const CREATE_DOCUMENT_TYPE = "CREATE_DOCUMENT_TYPE";
export const ADD_DOCUMENT_TYPE = "ADD_DOCUMENT_TYPE";
export const ORDER_DOCUMENTS_TYPES = "ORDER_DOCUMENTS_TYPES";
export const MOVE_DOCUMENT = "MOVE_DOCUMENT";
export const CREATE_DOCUMENT_LABEL = "CREATE_DOCUMENT_LABEL";
export const EDIT_DOCUMENT_LABEL = "EDIT_DOCUMENT_LABEL";
export const ATTACH_DOCUMENT_LABEL = "ATTACH_DOCUMENT_LABEL";
export const REMOVE_DOCUMENT_LABEL = "REMOVE_DOCUMENT_LABEL";
export const REMOVE_LABEL_FROM_DOCUMENT = "REMOVE_LABEL_FROM_DOCUMENT";
export const LOAD_DOCUMENT_LABELS = "LOAD_DOCUMENT_LABELS";
export const MARK_MESSAGES_AS_READ = "MARK_MESSAGES_AS_READ";
export const ORDER_DOCUMENTS_REQUESTS = "ORDER_DOCUMENTS_REQUESTS";
export const SEND_NEW_DOCUMENTS = "SEND_NEW_DOCUMENTS";
export const EXTRACT_DOCUMENT_VALUES = "EXTRACT_DOCUMENT_VALUES";
export const UPDATE_EXTRACTED_DOCUMENT_VALUES = "UPDATE_EXTRACTED_DOCUMENT_VALUES";
const actions = {
  [LOAD_DOCUMENTS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const {
        documents: documentClassifications
      } = await getDocumentClassifications(applicationId, clientUsername);
      const {
        entities: {
          classifications,
          comments,
          documents
        },
        result
      } = normalize(documentClassifications, [classificationListSchema]);
      context.commit(SET_DOCUMENTS, {
        documents: {
          byId: documents || {}
        },
        applicationId
      });
      context.commit(SET_DOCUMENT_COMMENTS, {
        comments: {
          byId: comments || {}
        },
        applicationId
      });
      context.commit(SET_DOCUMENT_CLASSIFICATIONS, {
        classifications: {
          byId: classifications || {},
          allIds: result || []
        },
        applicationId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [LOAD_REQUEST_LISTS]: async context => {
    try {
      const documentRequestLists = await getDocumentRequestList();
      const draftTemplateAlreadySet = !!context.state.DRAFT_TEMPLATE_NAME;
      const DRAFT_TEMPLATE_NAME = draftTemplateAlreadySet ? context.state.DRAFT_TEMPLATE_NAME : moment().unix() + "-draft";
      documentRequestLists.unshift({
        name: DRAFT_TEMPLATE_NAME,
        draft: true,
        documentRequests: []
      });
      if (!draftTemplateAlreadySet) {
        context.commit(SET_DRAFT_TEMPLATE_NAME, {
          DRAFT_TEMPLATE_NAME
        });
      }
      const {
        entities,
        result
      } = normalize(documentRequestLists, [documentRequestListSchema]);
      context.commit(SET_DOCUMENT_REQUEST_LISTS, {
        documentRequestLists: {
          byId: (entities == null ? void 0 : entities.documentRequestLists) || {},
          allIds: result || []
        }
      });
      context.commit(SET_DOCUMENT_REQUESTS, {
        documentRequests: {
          byId: (entities == null ? void 0 : entities.documentRequests) || {}
        }
      });
      context.commit(SET_SAMPLE_DOCUMENTS, {
        sampleDocuments: {
          byId: (entities == null ? void 0 : entities.sampleDocuments) || {}
        }
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_DOCUMENT]: async (context, {
    clientUsername,
    applicationId,
    fileName,
    documentId,
    download = true
  }) => {
    try {
      const {
        url
      } = await downloadDocument(documentId, fileName, applicationId, clientUsername, download);
      return {
        url
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_DOCUMENT_NO_CLIENT]: async (context, {
    fileName,
    documentId
  }) => {
    try {
      const {
        url
      } = await downloadDocumentNoClient(documentId, fileName);
      return url;
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_COMBINED_PDF]: async (context, {
    clientUsername,
    applicationId,
    documentRequestIds
  }) => {
    try {
      const {
        signedFileOptions: {
          url
        }
      } = await downloadAllDocumentsAsPdf(applicationId, clientUsername, documentRequestIds);
      return {
        url
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [GET_SIGNED_URL]: async (context, {
    fileName,
    clientUsername,
    documentRequestId
  }) => {
    try {
      return await getSignedURL(fileName, clientUsername, documentRequestId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [MARK_UPLOAD_COMPLETED]: async (context, {
    applicationId,
    classificationType,
    documentDescription,
    clientUsername,
    documentS3Key,
    documentRequestId,
    encrypted
  }) => {
    try {
      return await markUploadCompleted(clientUsername, applicationId, classificationType, documentDescription, documentS3Key, documentRequestId, encrypted);
    } catch (e) {
      Err.handle(e);
    }
  },
  [EMPTY_MARKED_DOCUMENT_CLASSIFICATIONS]: async context => {
    context.commit(CLEAR_MARKED_DOCUMENT_CLASSIFICATION);
  },
  [MARK_DOCUMENT_CLASSIFICATIONS]: async (context, {
    markedDocumentClassifications = []
  }) => {
    const markedMap = _reduceInstanceProperty(markedDocumentClassifications).call(markedDocumentClassifications, (acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
    context.commit(SET_MARKED_DOCUMENT_CLASSIFICATION, {
      markedDocumentClassifications: markedMap
    });
  },
  [UNMARK_DOCUMENT_CLASSIFICATIONS]: async (context, {
    markedDocumentClassifications = []
  }) => {
    const markedMap = _reduceInstanceProperty(markedDocumentClassifications).call(markedDocumentClassifications, (acc, key) => {
      acc[key] = false;
      return acc;
    }, {});
    context.commit(SET_MARKED_DOCUMENT_CLASSIFICATION, {
      markedDocumentClassifications: markedMap
    });
  },
  [SAVE_DOCUMENT_CLASSIFICATION_DESCRIPTION]: async (context, {
    applicationId,
    clientUsername,
    documentRequestId,
    description
  }) => {
    const {
      description: currentDescription
    } = context.state.classifications.byApplication[applicationId].byId[documentRequestId];
    try {
      context.commit(SET_DOCUMENT_CLASSIFICATION_DESCRIPTION, {
        documentRequestId,
        description,
        applicationId
      });
      await updateRequestDetails(applicationId, clientUsername, documentRequestId, {
        description
      });
    } catch (e) {
      context.commit(SET_DOCUMENT_CLASSIFICATION_DESCRIPTION, {
        documentRequestId,
        description: currentDescription,
        applicationId
      });
      Err.handle(e);
    }
  },
  [SAVE_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION]: async (context, {
    documentRequestId,
    description,
    documentRequestListName
  }) => {
    const {
      description: currentDescription,
      classification
    } = context.state.documentRequests.byId[documentRequestId];
    const draft = context.state.documentRequestLists.byId[documentRequestListName].draft;
    try {
      context.commit(SET_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION, {
        documentRequestId,
        description
      });
      if (!draft) {
        await updateDocumentRequestItem(documentRequestId, documentRequestListName, {
          description,
          classification
        });
      }
    } catch (e) {
      context.commit(SET_DOCUMENT_REQUEST_CLASSIFICATION_DESCRIPTION, {
        documentRequestId,
        description: currentDescription
      });
      Err.handle(e);
    }
  },
  [SEND_DOCUMENT_COMMENT]: async (context, {
    applicationId,
    documentId,
    comment,
    senderDetails
  }) => {
    const tempId = moment().unix().toString();
    try {
      const createdAt = moment().format();
      context.commit(ADD_DOCUMENT_COMMENT, {
        comment: _objectSpread({
          id: tempId,
          createdAt,
          comment
        }, senderDetails),
        applicationId,
        documentId
      });
      await sendComment(documentId, comment);
    } catch (e) {
      context.commit(REMOVE_DOCUMENT_COMMENT, {
        applicationId,
        documentId,
        commentId: tempId
      });
      Err.handle(e);
    }
  },
  [CREATE_DOCUMENT_CLASSIFICATIONS]: async (context, {
    applicationId,
    clientUsername,
    documentRequests
  }) => {
    try {
      const sampleDocuments = context.state.sampleDocuments;
      const {
        documentRequests: newRequests
      } = await createDocumentClassification(applicationId, clientUsername, documentRequests);
      const now = moment().format();
      newRequests.forEach(({
        documentRequestId,
        customOrder
      }, index) => {
        var _documentRequest$samp, _documentRequest$samp2;
        const documentRequest = documentRequests[index];
        const sampleDocumentsData = (_documentRequest$samp = documentRequest == null ? void 0 : (_documentRequest$samp2 = documentRequest.sampleDocuments) == null ? void 0 : _mapInstanceProperty(_documentRequest$samp2).call(_documentRequest$samp2, sampleDocumentId => {
          var _sampleDocuments$byId, _sampleDocuments$byId2;
          return (_sampleDocuments$byId = sampleDocuments == null ? void 0 : (_sampleDocuments$byId2 = sampleDocuments.byId) == null ? void 0 : _sampleDocuments$byId2[sampleDocumentId]) != null ? _sampleDocuments$byId : {};
        })) != null ? _documentRequest$samp : [];
        const generatedRealDocuments = sampleDocumentsToRealDocuments(sampleDocumentsData);
        context.commit(ADD_DOCUMENT_CLASSIFICATION, {
          applicationId,
          documentClassification: {
            documentRequestId,
            classification: documentRequest.documentType,
            description: documentRequest.description,
            applicationDocumentId: "",
            createdAt: now,
            customOrder,
            requestedAt: null,
            sent: false,
            updatedAt: now,
            status: "outstanding",
            documents: _mapInstanceProperty(generatedRealDocuments).call(generatedRealDocuments, ({
              documentId
            }) => documentId)
          }
        });
        context.commit(ADD_DOCUMENTS_TO_CLASSIFICATION, {
          applicationId,
          documentRequestId: documentRequestId,
          documents: generatedRealDocuments
        });
      });
      return newRequests || [];
    } catch (e) {
      Err.handle(e);
    }
    return [];
  },
  [LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATES]: async (context, templateType) => {
    try {
      const {
        templates
      } = await getEmailTemplates(templateType);
      const {
        entities,
        result
      } = normalize(templates, [documentRequestTemplateSchema]);
      context.commit(SET_DOCUMENT_REQUEST_EMAIL_TEMPLATES, {
        byId: entities.documentRequestTemplates || {},
        allIds: result
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_DOCUMENT_CLASSIFICATION]: async (context, {
    applicationId,
    clientUsername,
    documentRequestId
  }) => {
    const removedDocumentClassification = context.state.classifications.byApplication[applicationId].byId[documentRequestId];
    try {
      context.commit(REMOVE_DOCUMENT_CLASSIFICATION, {
        documentRequestId,
        applicationId
      });
      await deleteDocumentRequest(applicationId, clientUsername, documentRequestId);
    } catch (e) {
      context.commit(ADD_DOCUMENT_CLASSIFICATION, {
        applicationId,
        documentClassification: removedDocumentClassification
      });
      Err.handle(e);
    }
  },
  [LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATE]: async (context, templateId) => {
    try {
      const {
        template
      } = await getEmailTemplate(templateId);
      const {
        html
      } = template;
      context.commit(SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE, {
        templateId,
        html
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPLOAD_DOCUMENT_TO_CLASSIFICATION]: async (context, {
    applicationId,
    clientUsername,
    classification,
    files,
    fileName,
    notifyUser = true
  }) => {
    try {
      const newDocuments = [];
      const filesData = [];
      for (const file of files) {
        var _context;
        const name = fileName || _replaceAllInstanceProperty(_context = getFileName(file)).call(_context, " ", "-");
        filesData.push({
          fileName: name,
          data: file,
          type: file.type,
          url: "",
          documentId: uuidv4()
        });
      }
      const filesInfo = _mapInstanceProperty(filesData).call(filesData, file => ({
        fileName: file.fileName,
        type: file.type,
        size: file.data.size,
        documentId: file.documentId
      }));
      const groupedFilesData = groupBy(filesData, "documentId");
      const signedUrls = await createSignedUrls(filesInfo, applicationId, clientUsername, classification.documentRequestId);
      for (const {
        url,
        documentId
      } of signedUrls) {
        if (!isEmpty(groupedFilesData[documentId]) && !isEmpty(groupedFilesData[documentId][0])) {
          groupedFilesData[documentId][0].url = url;
        }
      }
      for (const file of filesData) {
        var _file$fileName, _file$fileName2, _context2;
        let isEncrypted = false;
        const extension = (_file$fileName = file.fileName) == null ? void 0 : _file$fileName.split(".").pop();
        if (extension === "pdf" || file.type === "application/pdf") {
          const PDFEncrypted = await isPDFEncrypted(file.data);
          if (PDFEncrypted) {
            showToast("info", `fileIsProtected|{fileName:${file.fileName}}`);
            isEncrypted = true;
          }
        }
        const rotatedFile = await rotateFileIfNeeded(file);
        const rawName = (_file$fileName2 = file.fileName) == null ? void 0 : _sliceInstanceProperty(_context2 = _file$fileName2.split(".")).call(_context2, 0, -1).join(".");
        await putS3Data(rotatedFile, file.url, file.type);
        const {
          applicationDocumentId,
          documentNumber
        } = await markUploadCompleted(clientUsername, applicationId.toString(), classification.classification, classification.description, file.documentId, classification.documentRequestId, isEncrypted);
        const now = moment().toISOString();
        const newDocument = {
          applicationDocumentId,
          classificationType: classification.classification,
          comments: [],
          createdAt: now,
          description: classification.description,
          documentId: file.documentId,
          documentNumber: documentNumber,
          documentRequestId: classification.documentRequestId,
          documentStatus: "active",
          fileName: `${rawName}.pdf`,
          isSample: false,
          requestClassification: classification.classification,
          requestCreatedAt: "",
          requestStatus: "outstanding",
          requestUpdatedAt: "",
          requestedAt: "",
          sent: false,
          updatedAt: now,
          uploaderUsername: context.rootGetters["AccountStore/CURRENT_USER_USERNAME"]
        };
        context.commit(ADD_DOCUMENTS_TO_CLASSIFICATION, {
          applicationId,
          documentRequestId: newDocument.documentRequestId,
          documents: [newDocument]
        });
        newDocuments.push(newDocument);
      }
      if (newDocuments.length > 0) {
        if (notifyUser) showToast("success", "documentsUploaded");
        return {
          newDocuments,
          withError: false
        };
      }
    } catch (e) {
      if (notifyUser) Err.handle(e);
      return {
        withError: true
      };
    }
  },
  [RENAME_DOCUMENT]: async (context, {
    applicationId,
    clientUsername,
    documentId,
    fileName
  }) => {
    const {
      fileName: oldFileName
    } = context.state.documents.byApplication[applicationId].byId[documentId];
    try {
      context.commit(EDIT_DOCUMENT_DETAILS, {
        applicationId,
        document: {
          documentId,
          fileName
        }
      });
      await renameDocument(documentId, fileName, clientUsername);
    } catch (e) {
      context.commit(EDIT_DOCUMENT_DETAILS, {
        applicationId,
        document: {
          documentId,
          fileName: oldFileName
        }
      });
      Err.handle(e);
    }
  },
  [UPDATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE]: async (context, {
    templateId,
    newHtml,
    name
  }) => {
    try {
      const newTemplateInfo = _objectSpread(_objectSpread({}, context.state.documentRequestTemplates.byId[templateId]), {}, {
        name,
        html: newHtml
      });
      await updateEmailTemplate(templateId, newTemplateInfo);
      context.commit(SET_DOCUMENT_REQUEST_EMAIL_TEMPLATE_DETAILS, {
        templateId,
        newTemplateInfo
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_DOCUMENT_FROM_CLASSIFICATION]: async (context, {
    applicationId,
    clientUsername,
    documentId,
    documentRequestId,
    isSample,
    documentNumber
  }) => {
    const document = context.state.documents.byApplication[applicationId].byId[documentId];
    try {
      context.commit(REMOVE_DOCUMENT_FROM_CLASSIFICATION, {
        applicationId,
        documentId,
        documentRequestId
      });
      await deleteDocument(clientUsername, applicationId, documentId, documentNumber, isSample, documentRequestId);
    } catch (e) {
      context.commit(ADD_DOCUMENTS_TO_CLASSIFICATION, {
        applicationId,
        documentRequestId,
        documents: [document]
      });
      Err.handle(e);
    }
  },
  [DELETE_DOCUMENT_REQUEST_EMAIL_TEMPLATE]: async (context, templateId) => {
    try {
      await deleteEmailTemplate(templateId);
      context.commit(REMOVE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, {
        templateId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_DOCUMENT_STATUS]: async (context, {
    applicationId,
    clientUsername,
    documentId,
    documentNumber,
    documentRequestId,
    requestStatus
  }) => {
    const document = context.state.documents.byApplication[applicationId].byId[documentId];
    try {
      context.commit(EDIT_DOCUMENT_DETAILS, {
        applicationId,
        document: {
          documentId,
          requestStatus
        }
      });
      await updateDocumentStatus(applicationId, clientUsername, documentRequestId, documentNumber, requestStatus);
    } catch (e) {
      context.commit(EDIT_DOCUMENT_DETAILS, {
        applicationId,
        documentRequestId,
        document: {
          documentId,
          requestStatus: document.requestStatus
        }
      });
      Err.handle(e);
    }
  },
  [CREATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE]: async (context, {
    newTemplateName,
    templateHtml,
    templateType
  }) => {
    try {
      const templateInfo = {
        description: "",
        html: templateHtml,
        name: newTemplateName,
        templateType
      };
      const {
        templateId
      } = await createEmailTemplate(templateInfo);
      context.commit(SET_NEW_DOCUMENT_REQUEST_EMAIL_TEMPLATE, _objectSpread(_objectSpread({}, templateInfo), {}, {
        id: templateId
      }));
      return templateId;
    } catch (e) {
      Err.handle(e);
    }
  },
  [DOWNLOAD_ALL_PDF]: async (context, {
    classifications,
    applicationId,
    clientUsername
  }) => {
    let result = true;
    let error;
    const fileName = `${applicationId}.zip`;
    try {
      const {
        signedFileOptions
      } = await downloadAllDocumentsAsZip(applicationId, clientUsername, classifications);
      openFileDialog(signedFileOptions == null ? void 0 : signedFileOptions.url, signedFileOptions == null ? void 0 : signedFileOptions.documentId);
    } catch (e) {
      if (e.responseJSON) {
        result = false;
        error = e;
      } else {
        const response = await pollApiCall(async () => {
          return await downloadDocument(fileName, fileName);
        });
        if (response) openFileDialog(response == null ? void 0 : response.url, response == null ? void 0 : response.documentId);
      }
    }
    if (!result) {
      const message = error ? error.responseJSON : i18n.t("notification-messages.requestToDownloadDocumentTimedOut");
      Err.handle(error, {}, message);
      Amplitude.logEvent("BULK_DOWNLOAD_DOCUMENTS", {
        clientUsername,
        applicationId,
        submissionStatus: "failed",
        requestType: "zip"
      });
    }
    return result;
  },
  [RESET_SECURE_DETAILS]: async (context, {
    applicationId,
    clientUsername,
    coApplicantId,
    requestId
  }) => {
    try {
      await resetGuestUpload(applicationId, clientUsername, coApplicantId, requestId);
      showToast("success", "pinReset");
    } catch (e) {
      Err.handle(e);
    }
  },
  [SAVE_REQUEST_LIST]: async (context, {
    documentRequestList,
    documentRequests
  }) => {
    try {
      const requestListExists = context.state.documentRequestLists.byId[documentRequestList.name];
      const documentRequestsToAdd = documentRequests;
      if (!documentRequestList.draft) {
        const {
          documentRequestListItemIds
        } = await createOrUpdateDocumentRequestList(_objectSpread(_objectSpread({}, documentRequestList), {}, {
          documentRequests
        }));
        const now = moment().format();
        documentRequestListItemIds.forEach((id, index) => {
          documentRequestsToAdd[index] = _objectSpread(_objectSpread({}, documentRequestsToAdd[index]), {}, {
            id,
            createdAt: now,
            updatedAt: now,
            draft: false,
            sampleDocuments: []
          });
        });
        if (!requestListExists) context.commit(ADD_DOCUMENT_REQUEST_LIST, {
          documentRequestListName: documentRequestList.name
        });
      }
      return context.commit(ADD_DOCUMENT_REQUEST_CLASSIFICATION, {
        documentRequestListName: documentRequestList.name,
        documentRequests: documentRequestsToAdd
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_REQUEST_LIST_ORDER]: async (context, {
    documentRequestListName,
    documentRequests
  }) => {
    try {
      const documentRequestList = context.state.documentRequestLists.byId[documentRequestListName];
      context.commit(SET_DOCUMENT_REQUEST_LIST, {
        documentRequestList,
        documentRequests
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [SAVE_REQUEST_LIST_ORDER]: async (context, {
    documentRequestListName,
    documentRequests
  }) => {
    try {
      updateDocumentRequestSort(documentRequestListName, documentRequests);
    } catch (e) {
      Err.handle(e);
    }
  },
  [DELETE_DOCUMENT_REQUEST_CLASSIFICATION]: async (context, {
    documentRequestListName,
    documentRequestId
  }) => {
    const removedDocumentRequest = context.state.documentRequests.byId[documentRequestId];
    try {
      context.commit(REMOVE_DOCUMENT_REQUEST_CLASSIFICATION, {
        documentRequestId,
        documentRequestListName
      });
      if (!removedDocumentRequest.draft) {
        await deleteDocumentRequestItem(documentRequestId, documentRequestListName);
      }
    } catch (e) {
      context.commit(ADD_DOCUMENT_REQUEST_CLASSIFICATION, {
        documentRequestListName,
        documentRequests: [removedDocumentRequest]
      });
      Err.handle(e);
    }
  },
  [DELETE_DOCUMENT_TEMPLATE]: async (context, {
    requestList
  }) => {
    const {
      documentRequests
    } = requestList;
    const {
      name
    } = requestList;
    const deletedDocuments = values(pick(context.state.documentRequests.byId, documentRequests));
    context.commit(DELETE_REQUEST_LIST, {
      documentRequestListName: name
    });
    const promises = _mapInstanceProperty(documentRequests).call(documentRequests, async documentRequestId => {
      return new _Promise((resolve, reject) => {
        deleteDocumentRequestItem(documentRequestId, name).then(() => {
          resolve("");
        }).catch(() => {
          reject(documentRequestId);
        });
      });
    });
    const batches = chunk(promises, 5);
    for (const batch of batches) {
      const results = await _Promise.allSettled(batch);
      const rejectedDocument = _findInstanceProperty(results).call(results, result => result.status === "rejected");
      if (!rejectedDocument) break;
      try {
        await deleteDocumentRequestItem(rejectedDocument.reason, name);
      } catch (error) {
        const toRestoreDocuments = slice(documentRequests, _indexOfInstanceProperty(documentRequests).call(documentRequests, rejectedDocument.reason), documentRequests.length);
        context.commit(ADD_DOCUMENT_REQUEST_LIST, {
          documentRequestListName: name
        });
        context.commit(ADD_DOCUMENT_REQUEST_CLASSIFICATION, {
          documentRequestListName: name,
          documentRequests: _filterInstanceProperty(deletedDocuments).call(deletedDocuments, document => document.id && _includesInstanceProperty(toRestoreDocuments).call(toRestoreDocuments, document.id))
        });
        Err.handle(error);
        return;
      }
    }
  },
  [RENAME_REQUEST_LIST_DOCUMENT]: async (context, {
    documentId,
    fileName
  }) => {
    const {
      fileName: oldFileName
    } = context.state.sampleDocuments.byId[documentId];
    try {
      context.commit(EDIT_REQUEST_LIST_DOCUMENT_DETAILS, {
        document: {
          documentId,
          fileName
        }
      });
      await renameDocument(documentId, fileName);
    } catch (e) {
      context.commit(EDIT_REQUEST_LIST_DOCUMENT_DETAILS, {
        document: {
          documentId,
          fileName: oldFileName
        }
      });
      Err.handle(e);
    }
  },
  [DELETE_DOCUMENT_FROM_REQUEST_CLASSIFICATION]: async (context, {
    documentId,
    documentRequestId
  }) => {
    const deletedDocument = context.state.sampleDocuments.byId[documentId];
    try {
      context.commit(REMOVE_DOCUMENT_FROM_REQUEST_CLASSIFICATION, {
        documentId,
        documentRequestId
      });
      await deleteDocumentRequestSample(documentRequestId, documentId);
    } catch (e) {
      context.commit(ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION, {
        documentRequestId,
        document: deletedDocument
      });
      Err.handle(e);
    }
  },
  [UPLOAD_DOCUMENT_TO_REQUEST_CLASSIFICATION]: async (context, {
    documentRequest,
    files
  }) => {
    try {
      if (!documentRequest.id) throw "Missing document id.";
      for (const file of files) {
        var _context3, _context4;
        const name = _replaceAllInstanceProperty(_context3 = file.name).call(_context3, " ", "-");
        const rawName = _sliceInstanceProperty(_context4 = name.split(".")).call(_context4, 0, -1).join(".");
        const signed = await getSignedURL(name);
        await putS3Data(file, signed.url, signed.contentType);
        const {
          documentNumber
        } = await markDocumentRequestUploadCompleted(documentRequest.id, signed.documentId);
        const now = moment().format();
        const newDocument = {
          documentNumber,
          classificationType: documentRequest.classification,
          createdAt: now,
          description: "",
          documentId: signed.documentId,
          documentRequestId: documentRequest.id,
          fileName: `${rawName}.pdf`,
          updatedAt: now
        };
        context.commit(ADD_DOCUMENT_TO_REQUEST_CLASSIFICATION, {
          documentRequestId: documentRequest.id,
          document: newDocument
        });
      }
    } catch (e) {
      Err.handle(e);
    }
  },
  [CLEAR_REQUEST_LIST]: async (context, {
    documentRequestListName
  }) => {
    context.commit(EMPTY_REQUEST_LIST, {
      documentRequestListName
    });
  },
  [UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS]: (context, {
    applicationId,
    documentRequestId,
    sent
  }) => {
    const requestedAt = moment().format();
    context.commit(SET_DOCUMENT_CLASSIFICATION_SENT_STATUS, {
      applicationId,
      documentRequestId,
      sent,
      requestedAt
    });
  },
  [LOAD_DOCUMENT_TYPES]: async context => {
    try {
      const {
        documentTypes
      } = await getDocumentTypes();
      const {
        entities,
        result
      } = normalize(documentTypes, [documentTypesSchema]);
      context.commit(SET_DOCUMENT_TYPES, {
        byId: entities.documentTypes || {},
        allIds: result || []
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [EDIT_DOCUMENT_TYPE]: async (context, {
    documentTypeId,
    title,
    description
  }) => {
    const oldDescription = context.state.documentTypes.byId[documentTypeId].description;
    const oldTitle = context.state.documentTypes.byId[documentTypeId].title;
    if (description === oldDescription && title === oldTitle) return;
    try {
      context.commit(UPDATE_DOCUMENT_TYPE, {
        documentTypeId,
        description,
        title
      });
      await updateDocumentType(documentTypeId, title, description);
    } catch (e) {
      context.commit(UPDATE_DOCUMENT_TYPE, {
        documentTypeId,
        description: oldDescription,
        title: oldTitle
      });
      Err.handle(e);
    }
  },
  [DELETE_DOCUMENT_TYPE]: async (context, documentTypeId) => {
    const deletedDocumentType = cloneDeep(context.state.documentTypes.byId[documentTypeId]);
    try {
      context.commit(REMOVE_DOCUMENT_TYPE, {
        documentTypeId
      });
      await deleteDocumentType(documentTypeId);
    } catch (e) {
      context.commit(ADD_DOCUMENT_TYPE, deletedDocumentType);
      Err.handle(e);
    }
  },
  [CREATE_DOCUMENT_TYPE]: async (context, title) => {
    try {
      const {
        documentTypeId,
        typeOrder
      } = await createDocumentType(title);
      context.commit(ADD_DOCUMENT_TYPE, {
        documentTypeId,
        title,
        typeOrder
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [ORDER_DOCUMENTS_TYPES]: async (context, {
    documentTypeOrder
  }) => {
    const oldDocumentsTypes = cloneDeep(context.state.documentTypes);
    try {
      const updatedDocumentTypes = map(documentTypeOrder, ({
        documentTypeId
      }, index) => ({
        id: documentTypeId,
        typeOrder: index + 1
      }));
      context.commit(SET_DOCUMENT_TYPES_ORDER, {
        documentTypes: updatedDocumentTypes
      });
      await documentTypesOrder(updatedDocumentTypes);
    } catch (e) {
      context.commit(SET_DOCUMENT_TYPES, {
        byId: oldDocumentsTypes.byId,
        allIds: oldDocumentsTypes.allIds
      });
      Err.handle(e);
    }
  },
  [ORDER_DOCUMENTS_REQUESTS]: async (context, {
    documentsClassifications,
    applicationId,
    clientUsername
  }) => {
    const oldClassifications = cloneDeep(context.state.classifications.byApplication[applicationId]);
    const documentsClassificationOrder = map(documentsClassifications, ({
      documentRequestId
    }, index) => ({
      documentRequestId,
      customOrder: index + 1
    }));
    try {
      context.commit(SET_DOCUMENT_REQUESTS_ORDER, {
        documentsClassificationOrder,
        applicationId
      });
      await documentRequestsOrder(documentsClassificationOrder, applicationId, clientUsername);
    } catch (e) {
      context.commit(SET_DOCUMENT_CLASSIFICATIONS, {
        classifications: oldClassifications,
        applicationId
      });
      Err.handle(e);
    }
  },
  [MOVE_DOCUMENT]: async (context, {
    applicationId,
    clientUsername,
    documentRequestId,
    documentId,
    documentNumber,
    newRequestId
  }) => {
    const document = context.state.documents.byApplication[applicationId].byId[documentId];
    await moveDocument(applicationId, clientUsername, documentRequestId, documentNumber, newRequestId);
    context.commit(REMOVE_DOCUMENT_FROM_CLASSIFICATION, {
      applicationId,
      documentId,
      documentRequestId
    });
    context.commit(ADD_DOCUMENTS_TO_CLASSIFICATION, {
      applicationId,
      documents: [document],
      documentRequestId: newRequestId
    });
    context.commit(EDIT_DOCUMENT_DETAILS, {
      applicationId,
      document: {
        documentId,
        documentRequestId: newRequestId
      }
    });
  },
  [CREATE_DOCUMENT_LABEL]: async (context, {
    label
  }) => {
    try {
      const {
        documentLabelId
      } = await createDocumentTag(label);
      context.commit(SET_DOCUMENT_LABEL, {
        label: _objectSpread(_objectSpread({}, label), {}, {
          id: documentLabelId
        }),
        isShared: label.shared
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [EDIT_DOCUMENT_LABEL]: async (context, {
    label,
    isShared
  }) => {
    try {
      await editDocumentTag(label);
      context.commit(SET_DOCUMENT_LABEL, {
        label,
        isShared
      });
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [ATTACH_DOCUMENT_LABEL]: async (context, {
    applicationId,
    documentId,
    label
  }) => {
    try {
      context.commit(ADD_DOCUMENT_LABEL, {
        applicationId,
        documentId,
        label
      });
      await addLabelToDocument(documentId, label.id);
    } catch (e) {
      Err.handle(e);
      context.commit(DELETE_LABEL_TO_DOCUMENT, {
        applicationId,
        documentId,
        labelId: label.id
      });
    }
  },
  [REMOVE_LABEL_FROM_DOCUMENT]: async (context, {
    applicationId,
    documentId,
    label
  }) => {
    try {
      context.commit(DELETE_LABEL_TO_DOCUMENT, {
        applicationId,
        documentId,
        labelId: label.id
      });
      await removeLabelToDocument(documentId, label.id);
    } catch (e) {
      context.commit(ADD_DOCUMENT_LABEL, {
        applicationId,
        documentId,
        label
      });
      Err.handle(e);
    }
  },
  [REMOVE_DOCUMENT_LABEL]: async (context, {
    labelId,
    isShared
  }) => {
    try {
      await deleteDocumentTag(labelId);
      context.commit(DELETE_DOCUMENT_LABEL, {
        labelId,
        isShared
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_DOCUMENT_LABELS]: async context => {
    try {
      var _normalizeUserLabels$, _normalizeUserLabels$2, _normalizeUserLabels$3, _normalizeBrokerageLa, _normalizeBrokerageLa2;
      await getDocumentLabels();
      const {
        documentLabels = [],
        customizationDocumentLabels = []
      } = await getDocumentLabels();
      const normalizeUserLabels = normalize(documentLabels, [documentLabelsSchema]);
      const userLabels = {
        byId: (_normalizeUserLabels$ = normalizeUserLabels == null ? void 0 : (_normalizeUserLabels$2 = normalizeUserLabels.entities) == null ? void 0 : _normalizeUserLabels$2.documentLabels) != null ? _normalizeUserLabels$ : {},
        allIds: (_normalizeUserLabels$3 = normalizeUserLabels == null ? void 0 : normalizeUserLabels.result) != null ? _normalizeUserLabels$3 : []
      };
      const normalizeBrokerageLabels = normalize(customizationDocumentLabels, [documentLabelsSchema]);
      const brokerageLabels = {
        byId: (_normalizeBrokerageLa = normalizeBrokerageLabels == null ? void 0 : (_normalizeBrokerageLa2 = normalizeBrokerageLabels.entities) == null ? void 0 : _normalizeBrokerageLa2.documentLabels) != null ? _normalizeBrokerageLa : {},
        allIds: (normalizeBrokerageLabels == null ? void 0 : normalizeBrokerageLabels.result) || []
      };
      context.commit(SET_DOCUMENT_LABELS, {
        brokerageLabels,
        userLabels
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [MARK_MESSAGES_AS_READ]: async (context, {
    applicationId,
    clientUsername,
    documentRequestId,
    documentId,
    documentNumber
  }) => {
    const oldNumber = context.state.documents.byApplication[applicationId].byId[documentId].nrOfNewComments;
    try {
      context.commit(SET_DOCUMENT_NEW_COMMENTS_NUMBER, {
        applicationId,
        documentId,
        number: 0
      });
      await markMessagesAsRead(applicationId, clientUsername, documentRequestId, documentNumber);
    } catch (e) {
      context.commit(SET_DOCUMENT_NEW_COMMENTS_NUMBER, {
        applicationId,
        documentId,
        number: oldNumber
      });
    }
  },
  [SEND_NEW_DOCUMENTS]: async (context, {
    applicationId,
    clientUsername,
    lenderName,
    docsToLender
  }) => {
    try {
      const body = {
        lenderName,
        docsToLender
      };
      await sendDocumentsToLender(body, applicationId, clientUsername);
    } catch (e) {
      Err.handle(e);
    }
  },
  [EXTRACT_DOCUMENT_VALUES]: async (context, {
    clientUsername,
    applicationId,
    fileName,
    documentId,
    documentType
  }) => {
    const data = await extractDocumentValues(documentId, fileName, documentType, applicationId, clientUsername);
    return data;
  },
  [UPDATE_EXTRACTED_DOCUMENT_VALUES]: async (context, {
    result,
    documentId
  }) => {
    context.commit(SET_EXTRACTED_VALUES, {
      result,
      documentId
    });
  }
};
export default actions;